export class MyProductAmountModel {
    public amount: number;


    constructor( amount: number =  null) {
        this.amount = amount;
    }
}


